import { SET_TYPE_OF_VIEW } from '#app/constants/chat.ts'

import { type State, type Action } from '#types/chat/index.ts'

export function setTypeOfView(state: State, action: Action): State {
	if (action.type !== SET_TYPE_OF_VIEW) {
		return state
	}

	return {
		...state,
		typeOfView: action.typeOfView,
	}
}
